import React, { FC } from 'react';

import styled from '@emotion/styled';
import * as ReactSelect from 'react-select';
import { variant, ComponentsType } from '@lucid/theme';

export interface DefaultDropdownOptionType {
  /** The label to be shown in the Dropdown menu. */
  label: string;
  /** The unique value for the label in the Dropdown menu. */
  value: string;
}

export type DropdownReactSelectProps = ReactSelect.Props;
export type DropdownReactSelectOptionProps = ReactSelect.OptionProps;

export interface DropdownProps extends DropdownReactSelectProps {
  /** Allows passing additional styles to the component. */
  className?: string;
  /** The available variants for the Dropdown component. */
  variant?: ComponentsType['Form']['Dropdown'];
}

const StyledReactSelect = styled(ReactSelect.default)(
  variant({
    scale: 'form.dropdown',
    variants: {
      defaultVariant: {}
    }
  }),
  {
    label: 'reactSelectDropdown'
  }
);

const Dropdown: FC<DropdownProps> = ({
  className,
  variant = 'default',
  ...rest
}) => (
  <StyledReactSelect
    {...rest}
    className={className}
    classNamePrefix="reactSelectDropdown"
    variant={variant}
  />
);

export { ReactSelect };
export { Dropdown };
export default Dropdown;
